module.exports = __webpack_public_path__ + "static/media/twitter.3f74c7b4.svg";